import type { OpenItem } from '@/api/hooks/useOpenItems';
import { ResolvePlanPreview } from './ResolvePlanPreview';

export function OpenItemDetail({ item, selected, onToggle }: { item: OpenItem; selected: boolean; onToggle: () => void }) {
  const selectable = item.status === 'draft' || item.status === 'reopened';
  return (
    <article className="border-b border-border p-4 last:border-b-0" data-testid={`open-item-${item.open_item_id}`}>
      <div className="flex items-start gap-3">
        {selectable && <input aria-label={`Select ${item.title}`} type="checkbox" checked={selected} onChange={onToggle} />}
        <div className="min-w-0 flex-1">
          <h3 className="font-semibold">{item.title}</h3>
          <p className="mt-1 text-sm">{item.message}</p>
          {item.answer_text && <p className="mt-2 border-l-2 border-border pl-3 text-sm text-muted-foreground">Owner answer: {item.answer_text}</p>}
          <ResolvePlanPreview status={item.status} />
        </div>
        <span className="text-xs text-muted-foreground">{item.status}</span>
      </div>
    </article>
  );
}

